// ── 통합 메뉴 출퇴근 탭 규칙 (2026-09-30 "통합에 있는 출퇴근 관리도 똑같이 — 합치는 것부터 디자인까지", 1a) ──
//   통합 메뉴는 DB 한 줄 = 메뉴 하나 = 열쇠 하나(INTEGRATED_MENU_{id}). 본사처럼 열쇠 두 개(출퇴근·달력 메뉴)는 그대로 두고:
//     출퇴근(attendance) 메뉴     = [달력][직원별 상세]  (서버 달력 주소도 출퇴근 메뉴를 받는다 — 본사 "관리 열쇠면 달력도")
//     출퇴근 달력(calendar) 메뉴  = [달력]만
//     그 외 종류                  = 탭 없음(fail-closed)
//   짝: 같은 회사 묶음의 출퇴근 메뉴가 **내 목록**(/api/my/integrated-menus = 내가 열쇠를 가진 메뉴)에 있으면 그 달력 메뉴는
//     사이드바에서 숨기고, 주소로 들어오면 짝 출퇴근 메뉴의 달력 탭으로 넘긴다. 회사 묶음이 하나라도 다르면 짝이 아니다
//     (보던 회사 범위가 말없이 바뀌지 않게). 통합 메뉴 관리는 같은 종류·같은 회사 묶음을 하나만 만들게 해서 짝은 많아야 하나.

export function integratedAttendanceTabs(featureType) {
  if (featureType === 'attendance') return ['calendar', 'detail'];
  if (featureType === 'calendar') return ['calendar'];
  return [];
}

// 회사 묶음 비교 열쇠 — 대문자·중복 제거·정렬(DB 에 직접 넣은 줄은 저장 때 정리를 안 거쳤을 수 있다). 비었으면 null.
function companySetKey(codes) {
  if (!Array.isArray(codes)) return null;
  const norm = [...new Set(codes.map((c) => String(c || '').trim().toUpperCase()).filter(Boolean))].sort();
  return norm.length > 0 ? norm.join(',') : null;
}

/** 달력 메뉴의 짝 = 내 목록 안의, 회사 묶음이 똑같은 출퇴근 메뉴. 달력 메뉴가 아니거나 짝이 없으면 null. */
export function findPairedAttendanceMenu(menu, list) {
  if (!menu || menu.feature_type !== 'calendar' || !Array.isArray(list)) return null;
  const key = companySetKey(menu.company_codes);
  if (!key) return null;
  return list.find((m) => m && m.feature_type === 'attendance'
    && Number(m.id) !== Number(menu.id)
    && companySetKey(m.company_codes) === key) || null;
}

/** 사이드바에 그릴 통합 메뉴 — 짝이 있는 달력 메뉴만 뺀다(그 달력은 짝 출퇴근 메뉴 안의 [달력] 탭이다). */
export function sidebarIntegratedMenus(list) {
  if (!Array.isArray(list)) return [];
  return list.filter((m) => !findPairedAttendanceMenu(m, list));
}
